const icon = (icon, type) => ({ icon, type });
const def = icon('file', '');
const excel = icon('file-excel', 'is-success');
const csv = icon('file-table', 'is-success');
const word = icon('file-word', 'is-info');
const powerpoint = icon('file-powerpoint', 'is-warning');
const pdf = icon('file-pdf', 'is-danger');
const archive = icon('archive', 'is-warning');
const image = icon('file-image', 'is-danger');
const video = icon('file-video', 'is-success');

const fileIcon = {
  xlsx: excel,
  xls: excel,

  csv: csv,

  doc: word,
  docx: word,

  ppt: powerpoint,
  pptx: powerpoint,

  pdf: pdf,

  zip: archive,
  rar: archive,
  tar: archive,

  mp4: video,
  avi: video,

  png: image,
  jpg: image,
  jpeg: image,
  gif: image,
  bmp: image,
};

const imageExtensions = ['png', 'jpeg', 'jpg', 'gif', 'bmp'];

export default class {
  file;

  constructor(file) {
    this.file = file;
  }

  isImage() {
    return imageExtensions.indexOf(this.getExtension()) >= 0;
  }

  getImageUrl() {
    if (!this.imageUrl) {
      if (this.file instanceof File) {
        this.imageUrl = URL.createObjectURL(this.file);
      } else if (this.file.path) {
        this.imageUrl = this.file.path;
      }
    }
    return this.imageUrl;
  }

  getExtension() {
    if (!this.extension) {
      this.extension = this.file.name.replace(/^.*?([^.]+)$/i, '$1').toLowerCase();
    }
    return this.extension;
  }

  getIconName() {
    return (fileIcon[this.getExtension()] || def).icon;
  }

  getIconType() {
    return (fileIcon[this.getExtension()] || def).type;
  }

  getHumanSize(factionDigits) {
    let bytes = this.file.size;

    if (Math.abs(bytes) < 1024) {
      return bytes + ' B';
    }
    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    do {
      bytes /= 1024;
      ++u;
    } while (Math.abs(bytes) >= 1024 && u < units.length - 1);

    return bytes.toFixed(factionDigits) + ' ' + units[u];
  }
}
